import Personalizations from "./Personalizations";

export default Personalizations;
